src/components/Post.vue
<template>
  <div class="about">
    <a id="back" @click="back()">戻る</a>
    <br />
    <img id="gazou" src="@/assets/photo01.jpg" />
    <h2>この大会について</h2>
    <div id="box">
      <div id="aboutText">
        新型コロナウイルス（SARS-CoV-2）が世界中で流行しています。
        日本でも外出自粛が叫ばれている中、同じように家で過ごしている学生と一緒に何かできないか考えた結果、
        このコンテストを開催することを決めました。運営者は全員小説を愛する大学生です。
        大した賞金を出すことはできませんが、応募していただいた作品全てに一言感想を述べさせていただく予定です。
        規定は大きく、感染症がテーマであること、かつ希望を感じられる話であること、の2つです。
        メールアドレスのみで参加可能です。奮ってご参加ください。
        <br />
        <br />
        <br />
        <div id="kuuhaku">
          <div class="no_cut">コロナにまけるな短編小説コンテスト 実行委員会</div>
          <div class="no_cut">実行委員長&nbsp;渡邊凌真</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "nomatch",
  data: () => ({}),
  methods: {
    back: function() {
      this.$router.go(-1);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.about {
  width: 100%;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
  cursor: pointer;
}
#box {
  width: 100%;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
}
#aboutText {
  text-align: left;
  margin-left: auto;
  margin-right: auto;
  width: fit-content;
  padding-left: 2%;
  word-wrap: break-word;
}
#gazou {
  width: 90%;
  max-width: 650px;
}
.no_cut {
  display: inline-block;
}
#kuuhaku {
  white-space: pre-wrap;
}
#back {
  margin-right: 80%;
  text-align: center;
}
</style>